import zhLocale from 'element-ui/lib/locale/lang/zh-TW'
const tw = {
    Layout: {
        'cart': '購物車',
        'navList': ["首頁", "商城", "陳列館", "新聞", "聯係我們"],
        'shopList': ['活動商城', '全價區', '半價區'],
        'contactList': ['加入我們', '在線留言'],
        'logOut': '登出',
        'logIn': '登入',
        'register': '註冊',
        'message': '消息',
        'myOrders': '我的訂單',
        'myFavor': '我的收藏',
        'currentLan': '繁體中文',
        'cartGoods': '件商品',
        'cartGoodsTotal': '共',
        'cartPrice': '共計',
        'buy': '結算',
        'cartEmpty': '購物車空空如也~',
        'messageEmpty':'暫無消息喔~'
    },
    HomePage: {
        'titleList': ['陳列館', '熱門銷售']
    },
    Shop: {
        'search': '搜索',
        'fullPrice': '全價區',
        'halfPrice': '半價區',
        'scale': '比例',
        'status': '狀態',
        'scaleList': ["全部比例", "1/1", "1/12", "1/18", "1/43", "1/64", "1/87"],
        // 'statusList': ["全部", "預售中", "熱賣中", "補款中", "已截單", "即將開售", "已售罄"],
        'statusList': [{ id: '', name: '全部' }, { id: '20', name: '預售中' }, { id: '10', name: '熱賣中' }, { id: '30', name: '補款中' }, { id: '40', name: '已截單' }, { id: '50', name: '即將開售' }, { id: '60', name: '已售罄' }],
    },
    News: {
        'newsType': [{ id: '0', name: '全部' }, { id: '1', name: '品牌新聞' }, { id: '2', name: '產品新聞' }, { id: '3', name: '活動新聞' }],
        'checkDetails': '查看詳情',
        'pages': ['共', '頁', '條信息']
    },
    Contact: {
        'titleName': ['加入我們', '在線留言', '聯繫方式'],
        'button': '提交',
        'typeList': [{ id: '0', name: '問題咨詢' }, { id: '1', name: '售後反饋' }, { id: '2', name: '建議投訴' }],
        'placeholders': ['你的名字', '你的姓氏', '你的性別', '求職崗位', '聯繫方式', '你的郵箱', '問題類型', '留言內容', '上傳附件（小於2M）'],
        'social': [
            { imgUrl: "static/img/wem.png", name: "Facebook" },
            { imgUrl: "static/img/wem.png", name: "微信" },
            { imgUrl: "static/img/wem.png", name: "新浪微博" },
            { imgUrl: "static/img/wem.png", name: "微信商城" }
        ],
        'info': [
            { name: "電話", val: "400-8818-792" },
            { name: "粉絲頁面", val: "www.facebook.com/kingartshk" },
            { name: "微博", val: "weibo.com/u/3906268664" },
            { name: "微信公眾號", val: "KingArtsHK" },
            { name: "電子郵箱", val: "info@guanxingroup.com" },
            { name: "網站", val: "www.king-arts.com" },
            { name: "公司地址", val: "香港皇后大道中181號新紀元廣場1501室" }
        ]
    },
    Personal: {
        'optionList': ['個人資料', '會員身份', '修改密碼', '我的訂單', '我的收藏', '我的購物車'],
        'formTtile': ['姓名', '性別', '電話', '郵箱', '郵編', '操作', '已保存收貨地址', '收貨人', '地址', '編輯', '刪除', '新建地址'],
        'dialogTitle': ['修改個人資料', '新增收貨地址', '修改收貨地址'],
        'del': '是否刪除當前地址',
        'tips': ['編輯資料成功', '新增地址成功', '刪除成功', '修改地址成功'],
        'sexList': [{ id: '0', name: '男' }, { id: '1', name: '女' }],
        'placeholders': ['請輸入姓名', '性別', '請輸入電話號碼', '請輸入郵箱地址', '請輸入收件人姓名', '請輸入收件人聯繫方式', '請選擇大洲', '請選擇國家', '請輸入詳細地址（包含省/市/街道）', '請輸入郵政編碼']
    },
    Member: {
        'title': ['我的等級', '積分規則及會員優惠'],
        'levels': ['普通會員', '白銀會員', '黃金會員', '鑽石會員'],
        'coupon': ['0折', '9.5折', '9折', '8折'],
        'tables': ['當前會員等級', '積分數量', '享受折扣數'],
        'diamond': ['您已成為', '可享受'],
        'note': ['購物增加積分', '一個月沒有進行消費'],
        'hints': ['您還差', '分就晉升為', '，將可以享受', '優惠'],
        'rule': '用戶在登錄註冊自動成為普通會員，默認等級為0，不享受任何折扣，用戶每消費一元就獲得一個積分，用戶積分達到1000分時，會員等級升為白銀會員，可享受9.5折優惠，用戶積分達到5000分時，會員等級升為黃金會員。可享受9折優惠，用戶積分達到10000分時，會員等級升為鑽石會員，可享受8折優惠。如果用戶一個月不產生消費記錄，用戶積分減少500分，用戶低于500分時再次減少歸零，不再減少。'

    },
    changePass: {
        'title': ['原密碼', '新密碼', '再次確認密碼'],
        'placeholders': ['請輸入原密碼', '請輸入8-20位字母+數字密碼', '請再次輸入新密碼'],
        'error': ['請輸入密碼', '請輸入正確格式的密碼', '請再次輸入密碼', '兩次輸入密碼不一致！'],
        'tips': '修改密碼成功',
    },
    favor: {
        'cancel': '取消收藏',
        'tips': '取消收藏成功',
        'dialog': ['是否取消收藏該商品？', '取消', '確認']
    },
    cart: {
        'table': ['商品信息', '單價', '數量', '會員優惠', '小計', '操作'],
        'dialog': ['是否刪除該商品', '取消', '確認'],
        'oper': ['加入收藏夾', '刪除'],
        'bottom': ['已選商品', '件 合計（不含運費）', '結算']
    },
    login: {
        'title': '登入',
        'placeholders': ['郵箱賬號', '請輸入密碼'],
        'tips': '登錄成功',
        'oper': ['註冊', '忘記密碼？']
    },
    regis: {
        'title': ['賬號', '驗證碼', '密碼', '確認密碼', '已有賬號？去'],
        'oper': ['獲取驗證碼', '註冊', '用戶勾選代表同意', '《冠霆服務條款》'],
        'placeholders': '請輸入4位驗證碼',
        'codetext': ['獲取驗證碼', '發送中...', '秒重新發送'],
        'error': ['請輸入郵箱', '請輸入正確的郵箱', '請輸入驗證碼', '請同意相關條款'],
        'tips': ['註冊成功', '驗證碼發送成功，請注意查收']
    },
    pay: {
        'title': ['選擇支付方式', '交易號', '實付', '支付方式', '立即支付'],
        'hints': '請打開微信支付'
    },
    orders: {
        'tabs': [{ id: '0', name: '所有訂單' }, { id: '1', name: '待支付' }, { id: '2', name: '待發貨' }, { id: '3', name: '待收貨' }, { id: '4', name: '待評價' }],
        // 'tabs': ['所有訂單', '待支付', '待發貨', '待收貨', '待評價'],
        'time': '下單時間',
        'oper': ['查看物流', '含運費', '去支付', '取消訂單', '查看詳情']
    },
    recovery: {
        'title': ['忘記密碼'],
        'tips': '重置密碼成功'
    },
    logi: {
        'title': ['物流詳情', '物流單號', '物流公司']
    },
    details: {
        'title': ['數量', '詳情', '評價'],
        'oper': ['分享', '收藏', '立即購買', '加入購物車'],
        'list':['定金','預售截止日期','請在','前補齊尾款','庫存','已售罄']
    },
    checkorder: {
        'title': ['訂單編號', '下單時間', '商品詳情',],
        'innerTitle': ['收貨人信息', '收貨人', '聯繫方式', '收貨地址', '商品總金額', '運送地區', '快遞公司', '運費', '應付總額'],
        'oper': ['取消訂單', '付款'],
        'label': ['商品信息', '單價', '數量', '會員優惠', '小計', '成交價格']
    },
    submitorder: {
        'title': ['選擇收貨地址', '管理收貨地址', '確認訂單信息', '備註信息', '提交訂單'],
        'hints': ['溫馨提示', '您購物已滿', '是否前往半價區進行挑選', '好的', '算了'],
        'half': ['半價區', '請在以下半價商品中挑選一件', '半價商品信息']
    },
    comment: {
        'title': '與描述是否相符',
        'placeholders': '說說你的感受吧'
    },
    public: {
        "regisbtn":'註冊',
        'annouce': '公告',
        'more': '更多',
        'confirm': '確定',
        'cancel': '取消',
        'sex': ['男', '女'],
        'prev': '上一頁',
        'next': '下一頁',
        'loginstatus': '尚未登入',
        'noitem':'購物車空空如也~',
        'money':'￥'
    },
    newword:{
        'new1':'請選擇一樣商品',
        'new2':'加入收藏成功',
        'new3':'移除購物車成功',
        'new4':'評價成功',
        'new5':'加入購物車成功',
        'new6':'取消訂單成功',
        'new7':'是否確認收貨?',
        'new8':'是否取消訂單?',
        'new9':'請輸入驗證碼',
        'new10':'確認刪除訂單?'
      }
}

export default tw;


// WEBPACK FOOTER //
// ./src/i18n/langs/tw.js